<template>
    <div class="cuerpo_row">
        <div class="cuerpo-column1">
            <nav class="navbar navbar-expand-xl navbar-dark bg-dark menutab-submenu">
                <h2 class="navbar-brand page-title"><!-- {{ dataView.nom }} --></h2>
                <button
                    class="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarsExample06"
                    aria-controls="navbarsExample06"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarsExample06">
                    <ul class="navbar-nav mr-auto">
                        <li
                            class="nav-item"
                            @click="changeModule('listExtraCategoria')"
                            v-bind:class="[modul === 'listExtraCategoria' ? 'active' : '']"
                        >
                            <a class="nav-link">
                                {{ $t("lang.label_categorys") }}
                            </a>
                        </li>
                        <li
                            class="nav-item"
                            @click="changeModule('listExtraAdicional')"
                            v-bind:class="[modul === 'listExtraAdicional' ? 'active' : '']"
                        >
                            <a class="nav-link">
                                {{ $t("lang.label_additionals") }}
                            </a>
                        </li>
                    </ul>
                    <ul class="navbar-nav menu-rigth">
                        <li class="nav-item">
                            <!-- <button type="button" class="btn btn-add-group">Add Category</button> -->
                        </li>
                    </ul>
                </div>
            </nav>
            <listExtraCategoria v-if="modul === 'listExtraCategoria'"></listExtraCategoria>
            <listExtraAdicional v-if="modul === 'listExtraAdicional'"></listExtraAdicional>
        </div>
        <!-- <div class="cuerpo-column2"></div> -->
    </div>
</template>

<script>
import listExtraAdicional from "@/components/dimenu/menu/listExtraAdicional";
import listExtraCategoria from "@/components/dimenu/menu/listExtraCategoria";
export default {
    name: "menu_categories",
    components: {
        listExtraAdicional,
        listExtraCategoria,
    },
    props: {
        subitems: { type: Object, required: true },
    },
    data () {
        return {
            isloading: false,
            modul: "listExtraCategoria",
            active: 0,
        }
    },
    methods: {
        changeModule(modul) {
            this.modul = modul;
        },
    },
}
</script>

<style lang="scss" scoped>
.cuerpo_row {
    min-height: calc(100vh - 5.5rem);
    width: 100%;
    display: flex;
    flex-direction: row;
    flex: 1 1 auto;
    overflow: hidden;
}
.cuerpo-column1 {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow: hidden;
}
.cuerpo-column2 {
    display: flex;
    flex-direction: column;
    flex: 0 0 320px;
    overflow: hidden;
    z-index: 20;
    background: #fff;
    border-left: 1px solid #d5d5d3;
    box-shadow: 0 1px 3px rgba(0, 1, 1, 0.25);
}
.sidebar-header {
    font-weight: 700;
    font-size: 17px;
    color: #727272;
    display: flex;
    background: #eee;
    padding: 0.4rem 1rem;
}
.sidebar-content {
    overflow: auto;
    padding: 0 15px;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
}
.menutab-submenu {
    background-color: #585858 !important;
    padding: 0rem 1rem;
    padding-left: 0px;
}
h2.navbar-brand.page-title {
    min-width: 0px;
    padding-bottom: 3px;
    padding-right: 0px;
    margin: 0;
}
.navbar-expand-xl .navbar-nav > li:nth-child(1) {
    cursor: pointer;
}

.navbar-expand-xl .navbar-nav > li.nav-item {
    padding: 0px;
    cursor: pointer;
}
.navbar-expand-xl .navbar-nav > li.nav-item > a {
    padding: 0.5rem 1rem;
    text-transform: inherit;
    // text-transform: uppercase;
    cursor: pointer;
}
.navbar-expand-xl .navbar-nav > li.nav-item > a.active,
.navbar-expand-xl .navbar-nav > li.nav-item > a:hover {
    background-color: #585858;
    color: #fff !important;
    font-weight: bold;
}
.btn-add-group {
    background-color: #fff;
    border-color: #ccc;
    cursor: pointer;
    position: relative;
    color: #666;
    width: 100% !important;
}
.btn-add-group:hover {
    color: #212529;
    background-color: #e0e0e0;
    border-color: #b3b2b2;
}
.nav-item.active {
    background-color: #019720;
    color: #fff !important;
}
</style>
